module.exports = __webpack_public_path__ + "media/src/public/fonts/Gals-Bold-464a77c743f93b334baa8cf52386fc08.woff2";